import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import DeleteAccountModal from "./deleteAccountModal";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { globalLoader, globalAlert } from "../../actions/commonActions";
import { userSelfDeleteConfirmApi, updateUserProfileApi } from "../../user/_userActions";
import { withRouter } from "../../_shared/withRouter";
import { logOut } from "../../_shared/commonFunction";
import {
  ORGANIZATION_LANGUAGE_CONTROL_ENABLED,
  SUPPORTED_LANGUAGES,
  withNativeNames,
} from "../../i18n/languages";
import LogoutModal from "../_common/logoutModal";
import {useSelector} from 'react-redux'
import LanguageSelector from "../_common/languageSelector";


const UserSettingsModal = (props) => {
  const { t, i18n } = useTranslation();
  const [openDeleteAccModal, setOpenDeleteAccModal] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [orgLanguages, setOrgLanguages] = useState(SUPPORTED_LANGUAGES);
  const [preferredLanguage, setPreferredLanguage] = useState(
    localStorage.getItem("userLanguage") || "en"
  );

  const userMsgCount = useSelector((state)=>state.user.msgCount)
  const orgDetails = useSelector((state) => state.common.orgDetails);

  useEffect(() => {
    // TEMPORARY: Keep all supported languages available to signed-in users.
    // FUTURE: When organisation language control is ready, enable the shared
    // feature flag to enforce the organisation's enabled/default languages.
    if (!ORGANIZATION_LANGUAGE_CONTROL_ENABLED) {
      setOrgLanguages(SUPPORTED_LANGUAGES);
      return;
    }

    const config = orgDetails?.configuration?.translationConfig;
    const configuredLanguages = config?.enabled === true &&
      Array.isArray(config?.enabledLanguages) &&
      config.enabledLanguages.length > 0
      ? withNativeNames(config.enabledLanguages)
      : [{ code: "en", name: "English" }];
    const allowedCodes = configuredLanguages.map((language) => language.code);
    const configuredDefault = allowedCodes.includes(config?.defaultLanguage)
      ? config.defaultLanguage
      : allowedCodes[0] || "en";

    setOrgLanguages(configuredLanguages);
    if (!allowedCodes.includes(preferredLanguage)) {
      setPreferredLanguage(configuredDefault);
      localStorage.setItem("userLanguage", configuredDefault);
      i18n.changeLanguage(configuredDefault);
    }
  }, [i18n, orgDetails, preferredLanguage]);

  const handleLanguageChange = async (lang) => {
    setPreferredLanguage(lang);
    try {
      await updateUserProfileApi({ preferredLanguage: lang });
      await props?.onLanguageChange?.(lang);
    } catch (err) {
      globalAlert("error", t("user.settings.failedToUpdateLanguage"));
    }
  };

  const closeOpenDeleteAccModal = () => {
    setOpenDeleteAccModal(false);
  };
  const deleteAcc = async (obj) => {
    globalLoader(true);
    let res = await userSelfDeleteConfirmApi(obj);
    if (res?.data?.status === 200) {
      globalAlert("success", res?.data?.message);// eslint-disable-next-line
      // eslint-disable-next-line
      props?.history?.push("/user/login");
    } else {
      globalAlert("error", res?.data?.message);
      globalLoader(false);
    }
  };

  const closeLogoutModal = (val) => {
    if (val) {
      logOut(props?.history, "/user/login");
    } else {
      setOpenLogoutModal(false);
    }
  };

  return (
    <Modal
      open={props?.open}
      onClose={() => {
        // eslint-disable-next-line
        props?.closeModal();
      }}
      center
      classNames={{
        modal: "setting-modal-own",
        overlay: "customOverlay",
        root: "modal-own-wrapper white-header-strip",
      }}
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <div className="settings-wrapper mx-auto">
        <div className="stripe pb-3 pt-5 border-bottom heading-wrapper">
          <p className="h4 heading text-center pt-3">{t("user.settings.title")}</p>
        </div>
        <div className="settings-menu pt-lg-5 px-lg-5 p-3 ">
          <div className="px-2 pb-3">
            <LanguageSelector
              languages={orgLanguages}
              value={preferredLanguage}
              onChange={handleLanguageChange}
              label={t("user.settings.preferredLanguage")}
            />
          </div>
          <ul className="list-unstyled settings-menu-list">
            {/* <li className="cursor">
              <div>Privacy Policy</div>
            </li> */}
            <li
              className="cursor"
              onClick={() => {
                window.open("/user/terms-and-conditions", "_blank");
              }}
            >
              <div className="settings-icons">
                <i className="far fa-file-alt"></i>
              </div>
              <div>{t("user.settings.termsAndConditions")}</div>
            </li>
            <li
              className="cursor "
              onClick={() => {
                // eslint-disable-next-line
                props?.setCurrentMenu(1);
                // eslint-disable-next-line
                props?.closeModal()
              }}
            >
              <div className="settings-icons">
                <i className="far fa-chalkboard-teacher"></i>
              </div>
              <div>{t("user.settings.education")}</div>
            </li>
            <li
              className="cursor "
              onClick={() => {
                // eslint-disable-next-line
                props?.setCurrentMenu(2);
                // eslint-disable-next-line
                props?.closeModal()
              }}
            >
              <div className="settings-icons">
                <i className="far fa-comment"></i>
              </div>
              <div>{t("user.settings.notifications")} {userMsgCount&& userMsgCount>0 ?<span className="badge-own">{userMsgCount}</span>:null}</div>
            </li>
           
            <li
              className="cursor"
              onClick={() => {
                setOpenLogoutModal(true);
                // logOut(props?.history, "/user/login");
              }}
            >
              <div className="settings-icons">
                <i className="fas fa-sign-out-alt"></i>
              </div>
              <div>{t("user.settings.logout")}</div>
            </li>
            <li
              className="cursor "
              onClick={() => {
                setOpenDeleteAccModal(true);
              }}
            >
              <div className="settings-icons">
                <i className="far fa-trash-alt"></i>
              </div>
              <div>{t("user.settings.deleteAccount")}</div>
            </li>
          </ul>
        </div>
      </div>
      {openDeleteAccModal && (
        <DeleteAccountModal
          open={openDeleteAccModal}
          closeModal={closeOpenDeleteAccModal}
          deleteAcc={deleteAcc}
        />
      )}
      {openLogoutModal && (
        <LogoutModal open={openLogoutModal} closeModal={closeLogoutModal} />
      )}
    </Modal>
  );
};

export default withRouter(UserSettingsModal);
